
<form #form="ngForm" [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Guardando entidad...">
<div class="row">
<div class="col-md-12">
  <nb-card>
    <nb-card-header>
      <nav class="navbar navigation">
        <span><nb-icon [icon]="iconos[tipoEntidad]" pack="font-awesome"></nb-icon> Configurar {{tituloEntidad}}</span>

        <button *ngIf="tipoEntidad != 'field'" class="space-left" nbButton shape="round" status="success" (click)="guardar()"><nb-icon icon="save-outline"></nb-icon>
          Guardar </button>

      </nav>

    </nb-card-header>

    <nb-card-body>


      <div class="row">
        <div class="col-sm-12">
          <ng2-smart-table *ngIf="tipoEntidad != 'field'" [settings]="entitysettings" [source]="source" (deleteConfirm)="deleteEntidad($event)">
          </ng2-smart-table>

          <ng2-smart-table *ngIf="tipoEntidad == 'field'" [settings]="parcelasettings" [source]="source" (edit)="editarParcela($event)" (create)="editarParcela($event)">
          </ng2-smart-table>
        </div>

      </div>



    </nb-card-body>
  </nb-card>
</div>



</div>

</form>

